// Abschluss-Dialog (Handoff Tickets): Erledigt/Geschlossen verlangen einen Abschlussgrund.
// Gemeinsam für Liste (Kanban-Ziehen) und Detailseite.
import { useState } from 'react';
import { CheckCircle } from '@phosphor-icons/react';
import { DialogHuelle, ImmoButton } from '../../../components/immobilien/ui';
import { STATUS_PILL } from '../../../components/ui/statusStyles';

export function AbschlussDialog({ ticketNummer, zielStatus, laeuft = false, onAbschliessen, onAbbrechen }: {
  ticketNummer: string;
  zielStatus: string;
  laeuft?: boolean;
  onAbschliessen: (grund: string) => void;
  onAbbrechen: () => void;
}) {
  const [grund, setGrund] = useState('');
  const label = STATUS_PILL[zielStatus]?.label ?? zielStatus;
  return (
    <DialogHuelle titel="Ticket abschließen" untertitel={`${ticketNummer} → ${label}`} icon={CheckCircle}
      iconFarbe={{ farbe: 'var(--ok)', flaeche: 'var(--ok-soft)' }} onSchliessen={onAbbrechen} laeuft={laeuft}
      fuss={<>
        <ImmoButton groesse={44} onClick={onAbbrechen} disabled={laeuft} style={{ flex: 1 }}>Abbrechen</ImmoButton>
        <ImmoButton art="akzent" groesse={44} onClick={() => onAbschliessen(grund.trim())} disabled={laeuft || !grund.trim()}
          data-tip="Abschließen – Status setzen und Grund speichern" style={{ flex: 1 }}>Abschließen</ImmoButton>
      </>}>
      <label className="flex flex-col" style={{ gap: 6 }}>
        <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--ink3)' }}>Abschlussgrund</span>
        <textarea autoFocus value={grund} onChange={e => setGrund(e.target.value)} rows={4} placeholder="Warum wird das Ticket geschlossen?"
          style={{ resize: 'vertical', borderRadius: 14, padding: '12px 14px', border: 'none', outline: 'none', background: 'var(--bg)',
            boxShadow: 'inset 0 0 0 1px var(--line)', color: 'var(--ink)', fontSize: 14, fontFamily: 'inherit', lineHeight: 1.45 }} />
      </label>
    </DialogHuelle>
  );
}
